export default "__VITE_ASSET__BvCEavT4__"